import { css } from "styled-components";
import { buildRulesets } from "./buildRulesets";
import "../designTokens/variables.css";

const fontFamily = css`
  font-family: var(--font-family-alpha);
`;

const textStyleToSizeMapping = {
  headline1: css`
    font-weight: var(--font-weight-light);
    font-size: var(--size-font-xxlarge);
    letter-spacing: var(--letter-spacing-widest);
    line-height: var(--line-height-60);
  `,
  headline2: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-extralarge);
    letter-spacing: var(--letter-spacing-wide);
    line-height: var(--line-height-50);
  `,
  headline3: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-large);
    letter-spacing: var(--letter-spacing-wide);
    line-height: var(--line-height-36);
  `,
  headline4: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-mediumlarge);
    letter-spacing: var(--letter-spacing-wide);
    line-height: var(--line-height-32);
  `,
  subtitle1: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-medium);
    letter-spacing: var(--letter-spacing-wider);
    line-height: var(--line-height-20);
  `,
  subtitle2: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-medium);
    letter-spacing: var(--letter-spacing-wider);
    line-height: var(--line-height-20);
  `,
  subtitle3: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-16);
  `,
  body1: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-16);
  `,
  body2: css`
    font-weight: var(--font-weight-semibold);
    font-size: var(--size-font-small);
    letter-spacing: var(--letter-spacing-tighter);
    line-height: var(--line-height-16);
  `,
  body3: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-small);
    letter-spacing: var(--letter-spacing-tighter);
    line-height: var(--line-height-16);
  `,
  caption: css`
    font-weight: var(--font-weight-medium);
    font-size: var(--size-font-extrasmall);
    letter-spacing: var(--letter-spacing-tight);
    line-height: var(--line-height-12);
  `,
};

const rulesets = buildRulesets({ fontFamily, textStyleToSizeMapping });

export const {
  primaryActive,
  primaryInactive,
  primaryDisabled,
  link,
  linkDisabled,
  warning,
  error,
  success,
  whiteActive,
  whiteInactive,
  whiteDisabled,
} = rulesets;
